module.exports = __webpack_public_path__ + "static/media/onboarding-end-animation.ad2a9239.svg";